<template>
    <div>
      <v-dialog v-model="abrirModalConfirmacaoEnvio" persistent :max-width="Modal.Confirmacao.larguraMaxima">
        <v-btn outline small color="primary" slot="activator">
            Solicitar Envio
        </v-btn>

        <v-card :max-width="Modal.Confirmacao.larguraMaxima" :min-width="Modal.Confirmacao.larguraMinima">
            <v-card-title class="primary modal-title" primary-title>
                Solicitar Envio
            </v-card-title>
            <v-card-text class="pb-0 az-form-content">
                <v-textarea v-model="mensagem"
                            :error-messages="errors.collect('Mensagem')"
                            v-validate="abrirModalConfirmacaoEnvio ? 'required' : ''"
                            :name="'Mensagem'"
                            label="Mensagem"
                            placeholder="Digite aqui uma mensagem"
                            rows="3"
                            maxlength="1000"
                            :counter="1000"
                            class="required-field"/>
            </v-card-text>
            <v-card-actions class="px-3 py-2">
                <v-btn color="botao-cancelar-color" flat outline @click="abrirModalConfirmacaoEnvio = false">
                  Cancelar
                </v-btn>
                <v-spacer/>
                <v-btn color="primary" depressed @click="confirmarSolicitacao">
                  Solicitar
                </v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>

<script>
import {Modal} from '@/core/constants'

export default {
    name: 'AcoesSolicitarEnvioDocumento',
    data() {
        return {
            mensagem: null,
            abrirModalConfirmacaoEnvio: false,
            Modal
        }
    },
    methods: {
        fecharDialogoConfirmacaoReenvio(){
            this.abrirModalConfirmacaoEnvio = false
        },
        async confirmarSolicitacao(){
            await this.validarCampos()
            this.fecharDialogoConfirmacaoReenvio()
            this.$emit('confirmarSolicitacaoEnvioDocumento', this.mensagem)
        },
        async validarCampos(){
            const estaValidado = await this.$validator.validateAll()
            if(!estaValidado){
                throw new Error('Preencha o campo mensagem!')
            }
        }
    }
}
</script>

<style scoped lang="stylus">
    .modal-title
        justify-content space-between

        .v-btn
          padding 0
          margin 0
          color #fff
          box-sizing border-box
          min-width 25px

    .botao-primario
      padding 0 25px
      border 1px solid var(--v-primary-base) !important
      background-color var(--v-primary-base) !important
      color #fff !important
      box-sizing border-box
      margin-left 15px !important

    .acoes
      padding 20px 0 !important

</style>
